import React, { useCallback, useState, useEffect } from "react";
import "./ShipmentManagementContent.scss";
import ShipmentMap from "../../ShipmentMap/ShipmentMap";
import ShipmentList from "../../ShipmentList/ShipmentList";
import ShipmentUpdate from "../../ShipmentUpdate/ShipmentUpdate";
import { useFetch } from "../../../utils/hooks";
import { Spin } from "antd";
import { getShipment, getShipmentsList } from "../../../services/shipments";
import { reduceShipmentsToPorts } from "../../../utils/utils";
import { useLocation } from "react-router-dom";

const ShipmentManagementContent = (props) => {
  const { tab, refetch: refetchTotals, bookingList, filterList, totals, setArchiveTotal } = props
  const { hash, pathname, search } = useLocation();

  const [page, setPage] = useState(1)
  const [selectedShipment, setSelectedShipment] = useState(null)

  const origin = pathname?.split("/").filter(s => s !== '')[0]

  const location = useLocation();
  // Extract "as" parameter from URL
  const searchParams = new URLSearchParams(location.search);
  const asParam = searchParams.get('as'); // This will extract the "as" parameter

  function clearSelectedShipment() {
    window.history.replaceState("", "", `/${origin}`);
    setSelectedShipment(null)
  }

  function selectShipment(shipment) {
    shipment.state && shipment.pol?.code && setSelectedShipment(shipment)
    window.history.pushState("", "", `/${origin}/explore#${shipment.url}`);
  }

  const { data, loading, refetch: refetchList } = useFetch(useCallback(() => {
    const params = {
      bookingList,
      filterList,
      as: asParam  // Pass the "as" parameter from the URL
    }
    if (tab == "starred") { params.star = true }
    if (tab == "attention") { params.attention = true }
    return getShipmentsList(params, page)
  }, [page, bookingList, filterList, totals]))

  useEffect(() => {
    window.addEventListener('filter', () => setPage(1))
  }, [page]);

  useEffect(() => {
    const exploreShipment = async () => {
      if (hash) {
        const res = await getShipment(hash.substring(1))
        selectShipment(res.data.shipment)
      }
    }

    exploreShipment();
  }, [hash])


  const refetch = () => {
    refetchTotals();
    refetchList();
  }

  const shipments = data?.shipments;
  const totalPages = data?.total
  const archiveTotal = data?.archive_total;
  const updates = data?.updates

  useEffect(() => {
    if(archiveTotal) {
      setArchiveTotal(archiveTotal)
    }
  }, [archiveTotal])
  

  const ports = shipments?.reduce(reduceShipmentsToPorts, {})

  if (loading) {
    return <Spin className="spinner" size="large" />
  }

  return (
    <div className="ShipmentManagementContent">
      <ShipmentMap ports={ports} selectShipment={selectShipment} />
      <ShipmentUpdate updates={updates} refetch={refetch} />
      <ShipmentList
        shipments={shipments}
        updates={updates}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        refetch={refetch}
        selectedShipment={selectedShipment}
        selectShipment={selectShipment}
        clearSelectedShipment={clearSelectedShipment}
        filters={{ bookingList, filterList }}
      />
    </div>
  )
};

export default ShipmentManagementContent;
